import styled from "styled-components"
import theme from "../../stylesheets/theme"

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 8px;
    background: white;
    border-radius: 8px;
`

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    flex-grow: 1;

    svg {
      height: 24px;
      width: 24px;
    }
`

export const Content = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2px;
    flex-grow: 1;

    .name {
      font-size: 14px;
      font-weight: 600;
      line-height: 1;
    }
    .number {
      font-size: 12px;
      color: gray;
      line-height: 1;
    }
` 

export const ActionButtonWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
`

export const ActionButton = styled.button`
    height: 34px;
    width: 34px;
    background: ${(props) => props.variant === "accept" ? "green" : "red"};
    color: white;
    border-radius: 8px;
    border: none;
    cursor: pointer;

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    svg {
      color: white;
    }
`

export const BetaBadge = styled.div`
  width: fit-content;
  padding: 2.5px 6px;
  background: ${theme.gray6};
  color: white;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 1px;
  border-radius: 10px;
`